<div class="deep-link-container" id="deeplinkContainer">
  <div class="deep-link-successfully-created" *ngIf="isSuccessfullySubmitted">
    <app-deep-link-created-info [selectedConfigurationName]="selectedConfigurationName ?? ''"></app-deep-link-created-info>
  </div>
  <div class="depp-link-info">
    <p class="depp-link-info-text" innerHTML="{{ 'view_translations.deep_link_info' | translate }}"></p>
  </div>
  <div class="select-configuration-container">
    <app-configuration-selection [currentCampaign]="currentCampaign" [submitted]="submitted" (emitConfig)="getPickedConfig($event)">
    </app-configuration-selection>
  </div>
  <app-loader *ngIf="modalLoading; else inputsContent"></app-loader>
  <ng-template #inputsContent>
    <ng-container *ngIf="this.landings && this.landings.length > 0">
      <app-input-select
        [label]="'choosing_landing_creation' | t"
        [options]="this.landings"
        [required]="false"
        [submitted]="submitted"
        [multiple]="false"
        [large]="true"
        [search]="false"
        (emitChange)="getLanding($event)">
      </app-input-select>
    </ng-container>
    <div class="input-container">
      <app-text-input
        [inputName]="'url_address'"
        [fieldInfo]="field"
        [autocomplete]="'on'"
        [backendError]="wrongURL"
        [submitted]="submitted"
        [validators]="['required','url']">
      </app-text-input>
    </div>
    <div class="input-container">
      <app-select-container
        *ngIf="selectData.data.length"
        [data]="selectData.data"
        [title]="selectData.title"
        [submitted]="submitted"
        [shouldTranslate]="false"
        (emitValue)="getSelectedValue($event)"
        [idOfDefaultValue]="idOfDefaultValue"
        [borderWidth]="2"
        [borderRadius]="10">
      </app-select-container>
    </div>
    <div class="information-link">
      <a href="#">{{ 'view_translations.how_choose_tracking_domain' | translate }}</a>
    </div>
  </ng-template>
  <app-loader *ngIf="isSuccessfullySubmitted && !isLoaded"></app-loader>
  <div class="generated-link-container" *ngIf="isSuccessfullySubmitted && isLoaded">
    <div class="generated-url-container">
      <h3>{{ 'view_translations.generated_deep_link' | translate }}</h3>

      <div class="text-input-container">
        <input type="text" readonly [value]="generatedDeeplink" #partnerProgramLink />
        <div class="copy-button global-transition" (click)="copyInputMessage(generatedDeeplink ?? '')">
          <nb-icon class="copy-icon" icon="copy" pack="icomoon"></nb-icon>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="btn-container" #backButtonRef *ngIf="!modalLoading">
  <app-primary-button
    [buttonText]="isSuccessfullySubmitted ? 'back_to_configuration_list' : 'generate_deep_link'"
    [icon]="isSuccessfullySubmitted ? '' : 'link'"
    [iconSize]="14"
    [background]="'orange'"
    (emitAction)="actionButton()">
  </app-primary-button>
</div>
